// components
import GridPageAbstract from '../../GridPageAbstract';
import { DiscountCircleBulkIcon } from '../../../icons-lib/bulkIcons';
import config from '../../../config';

export default class CurrencyExchangeRatesPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'currencyExchangeRates';
        this.Server =
            this.props.context.getState().server.currencyExchangeRates;

        this.headerStartIcon = DiscountCircleBulkIcon;

        this.searchFields = [
            'currencyExchangePair.fromCurrency.name',
            'currencyExchangePair.toCurrency.name'
        ];

        this.hiddenColumns = config?.hiddenColumns?.currencyExchangeRates || [];

        this.Head = [
            {
                id: 'currencyExchangePair',
                label: 'currencyExchangePair',
                alignRight: false,
                cell: 'FromTo',
                fromObj: 'fromCurrency',
                toObj: 'toCurrency',
                display: 'range',
                from: 'currencyExchangePairs',
                disableEditor: true,
                filterBy: 'currencyExchangePairs',
                filterCell: 'Context'
            },
            // Hidden in grid, used in dialog editor to send correct id to backend
            {
                id: 'currencyExchangePairsId',
                label: 'currencyExchangePair',
                alignRight: false,
                cell: 'Select',
                from: 'currencyExchangePairs',
                display: 'range',
                fromObj: 'fromCurrency',
                toObj: 'toCurrency',
                disableGrid: true
            },
            { id: 'rate', label: 'rate', alignRight: false, cell: 'Text' },
            {
                id: 'dateCreated',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            },
            {
                id: 'dateModified',
                label: 'dateCreated',
                alignRight: false,
                cell: 'Date',
                filterCell: 'Date',
                disableEditor: true
            }
        ].filter((column) => !this.hiddenColumns.includes(column.id));
    }
}
